export default __webpack_public_path__ + "static/media/lettre_chq.30c6b6b7.jpg";